export const dayLabel = date => {
  const today     = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  if (date.toDateString() === today.toDateString())     return I18n.t('ticket_assistant.today')
  if (date.toDateString() === yesterday.toDateString()) return I18n.t('ticket_assistant.yesterday')

  const options = { weekday: 'long', day: 'numeric', month: 'long' }
  if (date.getFullYear() !== today.getFullYear()) options.year = 'numeric'

  const label = date.toLocaleDateString(I18n.locale, options)
  return label.charAt(0).toUpperCase() + label.slice(1)
}
